var t;!function(t){t.Fast="Fast",t.Best="Best"}(t||(t={}));export{t as MatchType};
